<template>
  <div
      class="resource-table-container"
      :class="[(tableClass) ? tableClass + '-container' : false, {loading: loading, failed: failed}]"
  >
    <table class="resource-table mobile-hidden" :class="[tableClass]">
      <thead>
        <tr>
          <th v-for="column in columns" :class="[column.class ? column.class : [column.id]]">
            <span>{{ column.label }}</span>
          </th>
          <th class="actions" v-if="hasActions">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(result, index) in results" v-if="results.length">
          <td v-for="column in columns" :class="[column.class ? column.class : []]">
            <span v-if="column.type === 'boolean'">
              <svg-icon
                  :id="cellValue(column, result, index) ? 'check' : 'cross'"
                  class="icon"
                  :class="{error: !cellValue(column, result, index), success: cellValue(column, result, index)}"
              ></svg-icon>
            </span>
            <span v-else>{{ cellValue(column, result, index) }}</span>
          </td>
          <td class="actions" v-if="hasActions">
            <div class="action-list">
              <div class="action" v-for="action in result.actions">
                <button type="button" class="icon" :class="[action]" @click="triggerAction(result, action)">
                  <svg-icon :id="action"></svg-icon>
                </button>
              </div>
            </div>
          </td>
        </tr>
        <tr class="no-results" v-if="!results.length">
          <td :colspan="totalColumns" class="align-center">
            <div class="no-results"><p>{{ noResultsMessage }}</p></div>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="totalPages">
        <tr>
          <td class="pagination" :colspan="totalColumns">
            <pagination :current-page="page" :total-pages="totalPages" @change-page="changePage"></pagination>
          </td>
        </tr>
      </tfoot>
    </table>

    <table class="resource-table production-listing mobile-table mobile-visible">
      <tbody>
        <template v-for="(result, index) in results" v-if="results.length">
          <tr v-for="(column, cidx) in columns" :class="{'entry-break': (cidx === 0)}">
            <th>{{ column.label }}</th>
            <td>{{ cellValue(column, result, index) }}</td>
          </tr>
          <tr v-if="hasActions">
            <th>With Entry:</th>
            <td class="actions">
              <div class="action-list">
                <div class="action" v-for="action in result.actions">
                  <button type="button" class="icon" :class="[action]" @click="triggerAction(result, action)">
                    <svg-icon :id="action"></svg-icon>
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </template>
        <tr class="no-results" v-if="!results.length">
          <td class="align-center">
            <div class="no-results"><p>{{ noResultsMessage }}</p></div>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="totalPages">
        <tr>
          <td class="pagination" :colspan="totalColumns">
            <pagination :current-page="page" :total-pages="totalPages" @change-page="changePage"></pagination>
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="data-loader">
      <div class="data-loader-inner">
        <div class="data-loader-icon">
          <svg-icon id="loading" class="spin"></svg-icon>
        </div>
        <div class="data-loader-message">Loading data...</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    dataUrl: {
      type: String,
    },
    items: {
      type: Array,
    },
    itemsPerPage: {
      type: Number,
      default: 25,
    },
    tableClass: {
      type: String,
    },
    noResultsMessage: {
      type: String,
      required: false,
      default: 'There are no results to show here at this time.'
    }
  },
  mounted () {
    this.$eventBus.$on(`accountTableReload_${this.tableClass}`, () => {
      this.loadData()
    })
  },
  data () {
    return {
      failed: false,
      loading: false,
      perPage: this.itemsPerPage,
      page: 1,
      results: [],
      totalPages: 0,
    }
  },
  computed: {
    hasActions () {
      for (let result of this.results) {
        if (result.actions) {
          return true
        }
      }
      return false
    },
    totalColumns () {
      return this.columns.length + (this.hasActions ? 1 : 0)
    }
  },
  watch: {
    itemsPerPage () {
      this.loadData()
    },
    page () {
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    cellValue (column, result, index) {
      switch (column.type) {
        case 'rowCount':
          return ((this.page - 1) * this.perPage) + (index + 1)
          //case 'boolean':
          //    return this.findValueFromResult(result, column.id);
          //    break;
        case 'date':
        case 'datetime':
          return dayjs(this.findValueFromResult(result, column.id))
              .format(column.type === 'datetime' ? 'DD/MM/YYYY h:mA' : 'DD/MM/YYYY')
      }
      return this.findValueFromResult(result, column.id)
    },
    changePage (which) {
      this.page = which
    },
    findValueFromResult (src, path) {
      let resolved = src
      path = path.split(/\./g)

      for (let prop of path) {
        if (typeof resolved[prop] !== 'undefined') {
          resolved = resolved[prop]
        } else {
          return null
        }
      }
      return resolved
    },
    loadData () {
      if (!this.loading) {
        this.loading = true

        // Check with our backend
        axios.get(this.dataUrl, { params: { page: this.page } })
            .then((response) => {
              let data = response.data

              this.results = data.data
              this.page = data.current_page
              this.totalPages = data.last_page
              this.perPage = data.per_page

              this.$nextTick(() => {
                this.loading = false
                this.failed = false
              })
            })
            .catch(() => {
              this.loading = false
              this.failed = true
            })
      }
    },
    triggerAction (result, action) {
      this.$emit('action', { record: result, action: action })
    }
  }
}
</script>
